import { HttpClientModule } from '@angular/common/http';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { StateSlice } from '../state-slice';
import { initialAuthState } from './auth-state';
import { reducer } from './auth-reducer';
import { AuthEffects } from './auth-effects';
import { combineReducers } from '@core/utils/state';

@NgModule({
    imports: [
      // HttpClientModule,
      StoreModule.forFeature(StateSlice.AUTH, (reducer as ActionReducer<any, any>), {
        initialState: initialAuthState,
        reducerFactory: combineReducers
      }),
      EffectsModule.forFeature([ AuthEffects ])
    ],
    declarations: []
  })
  export class AuthStateModule {}
  